import * as actionTypes from '../config/actionTypes';
import * as commonActions from '../common/actions';
import * as forms from './forms';
import {
  // checkValidity,
  changeInputHandler,
  handleFormSubmit,
  updateFieldErrorsHandler,
  checkValidity,
  updateObject,
} from '../common/utility';
import axios from '../config/axios';
import Axios from "axios";


export const getAuthHeaders = (token) => {
  return {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
};


export const localLogout = () => {
  return {
    type: actionTypes.AUTH_LOGOUT,
  };
};


export const logout = (token) => {
  return (dispatch) => {
    if (token) {
      axios.post('/accounts/logout', {}, getAuthHeaders(token))
        .then(() => {
          dispatch(localLogout());
        })
        .catch(() => {
          dispatch(localLogout());
        });
    } else {
      dispatch(localLogout());
    }
  };
};


export const toggleLoading = () => {
  return {
    type: actionTypes.TOGGLE_AUTH_LOADING,
  };
};


export const toggleError = () => {
  return {
    type: actionTypes.TOGGLE_AUTH_ERROR,
  };
};


// move to common
export const noSiteFound = () => {
  return {
    type: actionTypes.NO_SITE_FOUND,
  };
};


export const storeAuthData = (data) => {
  return {
    type: actionTypes.STORE_AUTH_DATA,
    payload: data,
  };
};


export const stopAppLoading = () => {
  return {
    type: actionTypes.STOP_APP_LOADING,
  };
};

// review
export const checkAuth = () => {
  return (dispatch) => {
    const site = localStorage.getItem('site');
    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user'));
    if (!site) {
      dispatch(noSiteFound());
    }
    if (!token || !user) {
      dispatch(logout(token));
    }
    if (site) {
      dispatch(commonActions.siteSelectedFromLocal(site));
    }
    if (token && user) {
      dispatch(storeAuthData({ token: token, user: { ...user } }));  // eslint-disable-line
    }
    dispatch(stopAppLoading());
  };
};


export const postLogin = (data) => {
  return (dispatch) => {
    localStorage.setItem('token', data.token);
    localStorage.setItem('user', JSON.stringify(data.user));
    dispatch(storeAuthData(data));
  };
};


export const storeUserData = (data) => {
  return () => {
    localStorage.setItem('user', JSON.stringify(data));
  };
};


export const redirectToHome = () => {
  return () => {
    window.location.href = '/';
  };
};


export const printSuccessMsg = (data) => {
  return {
    type: actionTypes.PRINT_SUCCESS_MSG,
    payload: data,
  };
};


export const onUnmount = () => {
  return {
    type: actionTypes.AUTH_UNMOUNT,
  };
};


export const resetForm = (form) => {
  return {
    type: actionTypes.RESET_AUTH_FORM,
    payload: form,
  };
};

export const updateNonFieldErrors = (errors) => {
  return {
    type: actionTypes.UPDATE_AUTH_ERRORS,
    payload: errors,
  };
};


export const clearAuthErrors = () => {
  return {
    type: actionTypes.CLEAR_AUTH_ERRORS,
  };
};


export const manageAuthActionError = (error) => {
  return (dispatch) => {
    if (error.response.status === 401) {
      dispatch(localLogout());
      dispatch(redirectToHome(error.response.data));
    } else if (error.response.status === 403) {
      dispatch(storeUserData(error.response.data));
      dispatch(redirectToHome(error.response.data));
    }
  };
};


export const updateInputs = (form, data) => {
  return {
    type: actionTypes.UPDATE_AUTH_INPUTS,
    payload: { form: form, data: data }  // eslint-disable-line
  };
};


export const inputChangedHandler = (event, field, form, inputs) => {
  return (dispatch) => {
    const updatedControls = changeInputHandler(
        event,
        inputs,
        field,
    );
    dispatch(updateInputs(form, updatedControls));
  };
};


export const updateFieldErrors = (form, inputs, errorData) => {
  return (dispatch) => {
    const updatedInputs = updateFieldErrorsHandler(inputs, errorData);
    dispatch(updateInputs(form, updatedInputs));
  };
};


export const doEmailLoginHandler = (event, form, inputs) => {
  return (dispatch) => {
    dispatch(toggleLoading());
    const result = handleFormSubmit(event, inputs);

    if (result.formError) {
      // frontend error
      dispatch(toggleLoading());
      dispatch(updateInputs(form, result.inputs));
      dispatch(toggleError());
    }

    // no errors in frontend validation.. go ahead and axios it.

    if (Object.keys(result.fields).length === Object.keys(inputs).length) {
      const url = '/accounts/login';
      axios.post(url, { ...result.fields })
        .then((response) => {
          dispatch(postLogin(response.data));
        })
        .catch((error) => {
          dispatch(toggleLoading());
          dispatch(toggleError());
          dispatch(updateFieldErrors(form, inputs, error.response.data));
          if (error.response.data.non_field_errors) {
            dispatch(updateNonFieldErrors(error.response.data.non_field_errors));
          }
        });
    }
  };
};


export const initiatePasswordReset = (event, form, inputs) => {
  return (dispatch) => {
    dispatch(toggleLoading());
    const result = handleFormSubmit(event, inputs);

    if (result.formError) {
      // frontend error
      dispatch(toggleLoading());
      dispatch(updateInputs(form, result.inputs));
      dispatch(toggleError());
    }

    // no errors in frontend validation.. go ahead and axios it.

    if (Object.keys(result.fields).length === Object.keys(inputs).length) {
      const url = '/accounts/password-reset';
      axios.post(url, { ...result.fields })
        .then((response) => {
          dispatch(printSuccessMsg(response.data.success));
          dispatch(toggleLoading());
          dispatch(resetForm(form));
        })
        .catch((error) => {
          dispatch(toggleLoading());
          dispatch(toggleError());
          dispatch(updateFieldErrors(form, inputs, error.response.data));
          if (error.response.data.non_field_errors) {
            dispatch(updateNonFieldErrors(error.response.data.non_field_errors));
          }
        });
    }
  };
};


export const doSetPassword = (event, form, inputs, uid, token) => {
  return (dispatch) => {
    dispatch(toggleLoading());
    const result = handleFormSubmit(event, inputs);

    if (result.formError) {
      // frontend error
      dispatch(toggleLoading());
      dispatch(updateInputs(form, result.inputs));
      dispatch(toggleError());
    }

    // no errors in frontend validation.. go ahead and axios it.

    if (Object.keys(result.fields).length === Object.keys(inputs).length) {
      const url = '/accounts/password-set';
      const fields = { ...result.fields };
      fields.uid = uid;
      fields.token = token;
      axios.post(url, fields)
        .then((response) => {
          dispatch(printSuccessMsg(response.data.success));
          dispatch(toggleLoading());
          dispatch(resetForm(form));
        })
        .catch((error) => {
          dispatch(toggleLoading());
          dispatch(toggleError());
          dispatch(updateFieldErrors(form, inputs, error.response.data));
          if (error.response.data.non_field_errors) {
            dispatch(updateNonFieldErrors(error.response.data.non_field_errors));
          }
          if (error.response.data.uid || error.response.data.token) {
            dispatch(updateNonFieldErrors(['The password reset link is expired!']));
          }
        });
    }
  };
};


export const setOtpSent = (sent) => {
  return {
    type: actionTypes.SET_OTP_SENT,
    payload: sent,
  };
};


export const clearOtpField = () => {
  return (dispatch) => {
    dispatch(updateInputs('otpLoginForm', {
      otp: { ...forms.otpLoginForm.otp },
    }));
  };
};


const validateOtpInputs = (inputs, fields) => {
  let formError = false;
  let updatedInputs = inputs;

  fields.forEach((field) => {
    const validity = checkValidity(inputs[field].value, inputs[field].validation);
    if (!validity.isValid) {
      updatedInputs = updateObject(updatedInputs, {
        [field]: updateObject(inputs[field], {
          valid: false,
          touched: true,
          errorMsg: validity.errorMsg,
        }),
      });
      formError = true;
    }
  });

  return { formError, updatedInputs };
};


export const sendOtpHandler = (form, inputs, executeRecaptcha, isSignup = false) => {
  return (dispatch) => {
    dispatch(updateNonFieldErrors([]));
    const validation = validateOtpInputs(inputs, ['email']);

    if (validation.formError) {
      dispatch(updateInputs(form, validation.updatedInputs));
      return;
    }

    dispatch(toggleLoading());
    let url = '/accounts/send-otp';
    if (isSignup) {
      url += '?isSignup=1';
    }

    // 1. Generate the reCAPTCHA token silently
    if (!executeRecaptcha) {
      console.error('reCAPTCHA not ready yet.');
      dispatch(toggleLoading()); // Stop loading if reCAPTCHA is not ready
      return;
    }
    const captchaAction = 'request_otp';
    executeRecaptcha(captchaAction).then((captchaToken) => {
      // 2. Send the OTP request WITH the captcha token
      const requestData = {
        email: inputs.email.value,
        captchaToken,
        captchaAction,
      };

      axios.post(url, requestData)
          .then(() => {
            dispatch(toggleLoading());
            dispatch(setOtpSent(true));
          })
          .catch((error) => {
            dispatch(toggleLoading());
            if (error.response && error.response.data && error.response.data.error) {
              dispatch(updateNonFieldErrors([error.response.data.error]));
            } else {
              dispatch(toggleError());
            }
          });
    });
  };
};


export const doOtpLoginHandler = (form, inputs, executeRecaptcha, siteID, isSignup = false) => {
  return (dispatch) => {
    dispatch(updateNonFieldErrors([]));
    const validation = validateOtpInputs(inputs, ['email', 'otp']);

    if (validation.formError) {
      dispatch(updateInputs(form, validation.updatedInputs));
      return;
    }

    if (!executeRecaptcha) {
      console.error('reCAPTCHA not ready yet.');
      return;
    }

    dispatch(toggleLoading());

    let url = '/accounts/login-otp';
    if (isSignup) {
      url += '?isSignup=1';
    }

    const captchaAction = 'verify_otp';
    executeRecaptcha(captchaAction).then((captchaToken) => {
      const data = {
        email: inputs.email.value,
        otp: inputs.otp.value,
        captchaToken,
        captchaAction,
      };
      if (isSignup) {
        data.site_id = siteID;
      }

      axios.post(url, data)
        .then((response) => {
          Axios.get('https://ipapi.co/json/')
            .then((res) => {
              const token = response.data.token;
              const ipData = res.data;
              const apiData = {
                ip: ipData.ip,
                city: ipData.city,
                country: ipData.country_name,
                region: ipData.region,
                latitude: ipData.latitude,
                longitude: ipData.longitude,
              };
              axios.post('/disclaimers/complete-disclaimers', apiData, getAuthHeaders(token));
            });
          dispatch(setOtpSent(false));
          dispatch(postLogin(response.data));
        })
        .catch((error) => {
          dispatch(toggleLoading());
          if (error.response && error.response.data && error.response.data.error) {
            dispatch(updateNonFieldErrors([error.response.data.error]));
          } else {
            dispatch(toggleError());
          }
        });
    });
  };
};


export const doSocialLogin = (type, resp, siteID, token, fbcallback = false, isSignup = false) => {
  return (dispatch) => {
    dispatch(toggleLoading());

    if (resp.error) {
      console.log(">>>resp", resp);
      dispatch(toggleLoading());
      if (resp.error === 'idpiframe_initialization_failed') {
        dispatch(updateNonFieldErrors(['Please enable third party cookies from your browser settings for login to work properly. Or use a different browser.']));
      } else if (resp.error === 'popup_closed_by_user') {
        dispatch(updateNonFieldErrors(['Login popup closed by user']));
      } else if (resp.error === 'access_denied') {
        dispatch(updateNonFieldErrors(['Cannot login. User denied the permission to access data.']));
      } else if (resp.details) {
        dispatch(updateNonFieldErrors([resp.details]));
      } else {
        dispatch(updateNonFieldErrors(['Cannot login! Please contact lagnasetu@lohanamahaparishad.org']));
      }
    } else {
      const code = resp.accessToken;
      const data = {
        provider: type,
        code: code,  // eslint-disable-line
        site_id: siteID,
      };
      let headers = {};
      if (token) {
        headers = getAuthHeaders(token);
      }
      let url = 'accounts/social';
      if (isSignup) {
        url += '?isSignup=1';
      }
      axios.post(url, data, headers)
        .then((response) => {
          Axios.get('https://ipapi.co/json/')
            .then((res) => {
              const ip = res.data.ip
              const token = response.data.token
              const data = res.data
              const apiData = {
                "ip": data.ip,
                "city": data.city,
                "country": data.country_name,
                "region": data.region,
                "latitude": data.latitude,
                "longitude":data.longitude
              }
              axios.post('/disclaimers/complete-disclaimers', apiData, getAuthHeaders(token))
            })
          dispatch(postLogin(response.data));
          if (fbcallback) {
            window.location.href = '/';
          }
        })
        .catch((error) => {
          if (error.response.status === 401) {
            dispatch(logout(token));
          } else {
            dispatch(toggleLoading());
            if (error.response.data && error.response.data.error) {
              dispatch(updateNonFieldErrors([error.response.data.error]));
            } else {
              dispatch(toggleError());
            }
          }
        });
    }
  };
};



// WEBPACK FOOTER //
// ./src/auth/actions.js